import React, { useEffect, useRef, useState } from 'react';
import { useSnackbar } from 'notistack';
import { IconButton } from 'subframe/index';
import { AtomicTooltip } from './AtomicTooltip';
import { toastAutoHideDuration } from 'constants/toasts';

interface ClickToCopyProps {
  textToCopy: string;
  className?: string;
}

export const ClickToCopy: React.FC<ClickToCopyProps> = ({
  textToCopy,
  className,
}) => {
  const { enqueueSnackbar } = useSnackbar();
  const [copied, setCopied] = useState(false);
  const copiedTimer = useRef<number | null>(null);

  // Cleanup timer on unmount
  useEffect(() => {
    return () => {
      if (copiedTimer.current) {
        window.clearTimeout(copiedTimer.current);
      }
    };
  }, []);

  const handleCopy = () => {
    setCopied(true);
    if (copiedTimer.current) {
      window.clearTimeout(copiedTimer.current);
    }
    copiedTimer.current = window.setTimeout(() => {
      setCopied(false);
    }, 2000);
    navigator.clipboard.writeText(textToCopy);
    enqueueSnackbar('Copied to clipboard', {
      variant: 'success',
      autoHideDuration: toastAutoHideDuration,
    });
  };

  return (
    <AtomicTooltip tooltipContent={'Copy to clipboard'}>
      <IconButton
        icon={copied ? 'FeatherCheck' : 'FeatherClipboard'}
        className={className}
        onClick={handleCopy}
        size={'small'}
      />
    </AtomicTooltip>
  );
};
